export const CREDIT_REWARD_FOR_SIGN_UP = 15;
